import { useQuery } from "@tanstack/react-query";
import { CACHE_KEY_PURCHASEREQUESTS } from "../../../../utils/constants";
import { PRInterface } from "../../../../models/ProcurementModule/PurchaseRequest";
import PRService from "../../../../services/procurementService/PRService";

const usePR = (page: number, pageSize: number) =>
  useQuery<PRInterface[], Error>({
    queryKey: [CACHE_KEY_PURCHASEREQUESTS, page, pageSize],
    queryFn: () => PRService.GetAll(page, pageSize),
    initialData: [],
  });

export default usePR;
